<template>
  <div>
    <div class="d-sm-flex justify-end mb-5">
      <div class="mr-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click="$store.dispatch('getUsers')"
              v-bind="attrs"
              v-on="on"
              class="material-icons-round text-primary ms-auto"
              size="30"
            >
              refresh
            </v-icon>
          </template>
          <span>Aktualisieren</span>
        </v-tooltip>
      </div>
      <!-- <v-btn
        v-if="filter != ''"
        elevation="0"
        height="43"
        class="
          font-weight-bold
          text-uppercase
          shadow-none
          btn-default btn-outline-default
          py-2
          px-6
          me-2
          mb-sm-0 mb-2
        "
        color="transparent"
        small
        >Filter: {{ filter }}</v-btn
      >
      <div class="d-flex ms-auto">
        <v-menu transition="slide-y-transition" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              elevation="0"
              height="43"
              class="
                font-weight-bold
                text-uppercase
                btn-default btn-outline-default
                shadow-none
                py-2
                px-6
                me-2
              "
              color="transparent"
              small
            >
              Filters
              <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
            </v-btn>
          </template>

          <v-list class="py-0">
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = 'Eingelöst'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Status: Eingelöst
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="list-item-hover-active pb-2"
              @click="filter = 'Nicht eingelöst'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Status: Nicht eingelöst
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <hr class="horizontal dark" />
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = ''"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-danger ls-0 font-weight-600 mb-0"
                >
                  Filter entfernen
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          elevation="0"
          height="43"
          class="
            font-weight-bold
            text-uppercase
            btn-default btn-outline-default
            shadow-none
            py-2
            px-6
            me-2
          "
          color="transparent"
          small
          @click="csvExportEntries(event)"
        >
          <v-icon>ni ni-archive-2 me-1</v-icon>
          Export CSV
        </v-btn>
      </div> -->
    </div>
    <v-card class="card-shadow border-radius-xl">
      <!-- <div class="card-header-padding">
        <v-row class="mt-0 ml-1" justify="space-between">
          <div class="mr-2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="$store.dispatch('getEventsAdmin')"
                  v-bind="attrs"
                  v-on="on"
                  class="material-icons-round text-primary ms-auto"
                  size="30"
                >
                  refresh
                </v-icon>
              </template>
              <span>Aktualisieren</span>
            </v-tooltip>
          </div>
        </v-row>
      </div> -->

      <v-card-text class="px-0 py-0">
        <v-data-table
          :headers="headers"
          :items="users.data"
          :search="search"
          class="table"
          :page.sync="page"
          hide-default-footer
          @page-count="pageCount = $event"
          :items-per-page="itemsPerPage"
          mobile-breakpoint="0"
        >
          <template v-slot:top>
            <v-toolbar flat height="80">
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field
                    hide-details
                    class="input-style font-size-input text-light-input placeholder-light input-icon"
                    dense
                    flat
                    filled
                    solo
                    height="43"
                    v-model="search"
                    placeholder="Suche"
                  >
                    <template slot="prepend-inner">
                      <v-icon
                        color="#adb5bd"
                        size="16"
                        class="material-icons-round mt-n2"
                        >search</v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="600px">
                <v-card class="card-shadow border-radius-xl">
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0">{{
                      formTitle
                    }}</span>
                  </div>
                  <v-card-text class="card-padding">
                    <div class="mb-3 text-h2">
                      Accountstatus:
                      <span
                        :style="
                          editedItem.suspended ? 'color: red' : 'color: green'
                        "
                      >
                        {{ editedItem.suspended ? "GESPERRT" : "AKTIV" }}</span
                      >
                    </div>
                    <v-card elevation="3" style="position: relative" class="">
                      <v-img
                        height="350"
                        :src="getImage(editedItem.cover)"
                      ></v-img>

                      <v-list-item-avatar
                        rounded
                        :size="120"
                        class="my-0 me-4 white rounded-circle"
                        style="position: absolute; top: 290px; left: 15px"
                      >
                        <v-img
                          style="width: 89%; height: 90%"
                          :alt="editedItem.avatar"
                          :src="getImage(editedItem.avatar)"
                          class="rounded-circle ma-2"
                        ></v-img>
                      </v-list-item-avatar>
                      <div class="pt-15 mt-2 pa-5">
                        <div class="font-weight-bold text-h4">
                          {{ editedItem.fullname }}
                        </div>
                        <div class="font-weight-light text-h6">
                          {{ editedItem.username }} ●
                          {{
                            editedItem.adressData
                              ? editedItem.adressData.city
                              : ""
                          }}
                        </div>
                        <div class="font-weight-medium text-h6 mt-5">
                          {{ editedItem.characteristics }}
                        </div>
                        <div class="font-weight-light text-h6 mt-5">
                          {{ editedItem.email }}
                        </div>
                      </div>
                    </v-card>
                    <!-- <v-card
                      elevation="3"
                      style="position: relative"
                      class="pa-5 mt-5"
                    >
                      <div class="font-weight-bold text-h4">Überblick</div>
                      <v-row>
                        <v-col cols="6">
                            <div class="text-h5">Quests abgeschlossen</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-h5">Quests abgeschlossen</div>
                        </v-col>
                      </v-row>
                    </v-card> -->

                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.suspensionReason"
                        :disabled="editedItem.suspended"
                        hide-details
                        class="input-style font-size-input text-light-input placeholder-light input-icon mt-4"
                        dense
                        flat
                        outlined
                        height="43"
                        label="Grund für Sperrung"
                      ></v-text-field>
                      <div v-if="editedItem.suspended" class="mt-3">
                        Sperrdatum:
                        {{
                          editedItem.suspensionDate | moment("DD.MM.YYYY HH:mm")
                        }}
                      </div>
                    </v-col>
                  </v-card-text>

                  <v-card-actions class="card-padding d-flex justify-end">
                    <v-btn
                      v-if="!editedItem.suspended"
                      @click="save"
                      :disabled="
                        !editedItem.suspensionReason ||
                        editedItem.suspensionReason.length < 4
                      "
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-danger bg-gradient-danger py-3 px-6"
                      >Nutzer sperren</v-btn
                    >
                    <v-btn
                      v-else
                      @click="save"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-success bg-gradient-success py-3 px-6"
                      >Nutzer entsperren</v-btn
                    >
                    <v-btn
                      @click="close"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                      >schließen</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="premiumDialog" max-width="600px">
                <v-card class="card-shadow border-radius-xl">
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0">{{
                      formTitle
                    }}</span>
                  </div>
                  <v-card-text class="card-padding">
                    <div class="mb-3 text-h3">
                      Premiumstatus:
                      <span>
                        {{
                          editedItem.premiumExpires | moment("DD.MM.YYYY HH:mm")
                        }}</span
                      >
                    </div>
                    <v-card elevation="3" style="position: relative" class="">
                      <v-img
                        v-if="editedItem.cover"
                        height="350"
                        :src="getImage(editedItem.cover)"
                      ></v-img>

                      <v-list-item-avatar
                        v-if="editedItem.avatar"
                        rounded
                        :size="120"
                        class="my-0 me-4 white rounded-circle"
                        style="position: absolute; top: 290px; left: 15px"
                      >
                        <v-img
                          style="width: 89%; height: 90%"
                          :alt="editedItem.avatar"
                          :src="getImage(editedItem.avatar)"
                          class="rounded-circle ma-2"
                        ></v-img>
                      </v-list-item-avatar>
                      <div class="pt-15 mt-2 pa-5">
                        <div class="font-weight-bold text-h4">
                          {{ editedItem.fullname }}
                        </div>
                        <div class="font-weight-light text-h6">
                          {{ editedItem.username }} ●
                          {{
                            editedItem.adressData
                              ? editedItem.adressData.city
                              : ""
                          }}
                        </div>
                        <div class="font-weight-medium text-h6 mt-5">
                          {{ editedItem.characteristics }}
                        </div>
                        <div class="font-weight-light text-h6 mt-5">
                          {{ editedItem.email }}
                        </div>
                      </div>
                    </v-card>
                    <!-- <v-card
                      elevation="3"
                      style="position: relative"
                      class="pa-5 mt-5"
                    >
                      <div class="font-weight-bold text-h4">Überblick</div>
                      <v-row>
                        <v-col cols="6">
                            <div class="text-h5">Quests abgeschlossen</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-h5">Quests abgeschlossen</div>
                        </v-col>
                      </v-row>
                    </v-card> -->
                    <v-row class="ma-5 justify-space-between">
                      <v-cols
                        cols="3"
                        v-for="period in premiumPeriods"
                        :key="period.value"
                      >
                        <v-btn
                          @click="selectedPremiumPeriod = period.value"
                          elevation="0"
                          :ripple="false"
                          height="43"
                          class="font-weight-normal text-capitalize btn-ls py-3 px-6"
                          :class="
                            selectedPremiumPeriod == period.value
                              ? 'bg-gradient-success'
                              : 'btn-outline-secondary'
                          "
                          >{{ period.text }}</v-btn
                        >
                      </v-cols>
                    </v-row>

                    <v-col cols="12">
                      <div v-if="editedItem.premiumExpires" class="mt-3">
                        Premium aktiv bis:
                        {{
                          editedItem.premiumExpires | moment("DD.MM.YYYY HH:mm")
                        }}
                      </div>
                    </v-col>
                  </v-card-text>

                  <v-card-actions class="card-padding d-flex justify-end">
                    <v-btn
                      @click="setPremium()"
                      :disabled="!selectedPremiumPeriod"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-success bg-gradient-success py-3 px-6"
                      >Gratis Premium gewähren</v-btn
                    >

                    <v-btn
                      @click="close, (premiumDialog = false)"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                      >schließen</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showParticipantsDialog" max-width="600px">
                <v-card
                  class="card-shadow card-padding border-radius-xl"
                  v-if="!editedItem.participant_data"
                >
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0"
                      >Grund der Suspendierung</span
                    >
                  </div>
                  <v-card-text class="card-padding">
                    <v-container class="px-0">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.firstname"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Vorname"
                            label="Vorname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.lastname"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Nachname"
                            label="Nachname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.email"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="E-Mail-Adresse"
                            label="E-Mail-Adresse"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.street"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Straße"
                            label="Straße"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.zip"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Postleitzahl"
                            label="Postleitzahl"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.city"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Ort"
                            label="Ort"
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="6">
                          <v-btn
                            @click="
                              emailResended ? null : resendEmail(editedItem)
                            "
                            elevation="0"
                            :ripple="false"
                            height="43"
                            class="
                              font-weight-normal
                              text-capitalize
                              btn-ls btn-primary
                              py-3
                              px-6
                            "
                            :class="
                              emailResended == editedItem._id
                                ? 'bg-gradient-success'
                                : 'bg-gradient-info'
                            "
                            >{{
                              emailResended == editedItem._id
                                ? "Ticket-E-Mail gesendet!"
                                : "Ticket-E-Mail erneut senden"
                            }}</v-btn
                          >
                        </v-col> -->
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions class="pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="close"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls bg-transparent btn-outline-secondary py-3 px-6"
                      >schließen</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
                <v-card class="card-shadow border-radius-xl" v-else>
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0"
                      >Angemeldeter Teilnehmer</span
                    >
                  </div>
                  <v-card-text class="card-padding">
                    <v-container class="px-0">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.participant_data.name"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Name"
                            label="Name"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.participant_data.street"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Straße"
                            label="Straße"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.participant_data.zipcode"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Postleitzahl"
                            label="Postleitzahl"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.participant_data.city"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Ort"
                            label="Ort"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions class="card-padding d-flex justify-end">
                    <v-btn
                      @click="close"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                      >schließen</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogNoInvoice" max-width="500px">
                <v-card class="card-shadow card-padding border-radius-xl">
                  <v-card-title class="pt-0 text-h5 text-typo justify-center"
                    >Keine Rechnung vorhanden</v-card-title
                  >
                  <v-card-actions class="pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="closeNoInvoice"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls bg-transparent btn-outline-secondary py-3 px-6"
                      >schließen</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.fullname="{ item }">
            <v-list class="py-0">
              <v-list-item class="px-0 py-1">
                <v-list-item-avatar rounded :size="36" class="my-0 me-4">
                  <v-img
                    :alt="item.avatar"
                    :src="getImage(item.avatar)"
                    class="rounded-circle"
                  ></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="mb-0 text-sm text-typo font-weight-normal"
                    >{{ item.fullname }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>

          <template v-slot:item.email="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.email }}
            </span>
          </template>

          <template v-slot:item.suspended="{ item }">
            <div class="d-flex align-center" style="max-width: 50px">
              <v-btn
                :ripple="false"
                icon
                outlined
                rounded
                width="25px"
                height="25px"
                class="me-2"
                :class="!item.suspended ? 'border-success' : 'border-danger'"
              >
                <v-icon
                  size="8"
                  :class="!item.suspended ? 'text-success' : 'text-danger'"
                >
                  {{ !item.suspended ? "fas fa-check" : "fas fa-times" }}
                </v-icon>
              </v-btn>
              <!-- <span class="text-body text-xs">{{ item.status }}</span> -->
            </div>
          </template>

          <template v-slot:item.isVerified="{ item }">
            <div class="d-flex align-center">
              <v-btn
                :ripple="false"
                icon
                outlined
                rounded
                width="25px"
                height="25px"
                class="me-2"
                :class="item.isVerified ? 'border-success' : 'border-default'"
              >
                <v-icon
                  size="8"
                  :class="item.isVerified ? 'text-success' : 'text-dark'"
                >
                  {{ item.isVerified ? "fas fa-check" : "fas fa-times" }}
                </v-icon>
              </v-btn>
              <span class="text-body text-xs">{{ item.status }}</span>
            </div>
          </template>

          <template v-slot:item._id="{ item }">
            <v-btn
              @click="editItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">search</v-icon>
            </v-btn>
            <v-btn
              @click="grantPremium(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">star</v-icon>
            </v-btn>

            <!-- <v-btn
              @click="showParticipants(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">person</v-icon>
            </v-btn> -->
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="card-padding">
        <v-row>
          <v-col cols="6" lg="3" class="d-flex align-center">
            <span class="text-body me-3 text-sm">Einträge pro Seite:</span>
            <v-text-field
              hide-details
              type="number"
              outlined
              min="-1"
              max="15"
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              :value="itemsPerPage"
              @input="itemsPerPage = parseInt($event, 10)"
              placeholder="Items per page"
              class="font-size-input placeholder-lighter text-color-light input-alternative input-focused-alternative input-icon"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" class="ml-auto d-flex justify-end">
            <v-pagination
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              class="pagination"
              color="#D81B60"
              v-model="page"
              :length="pageCount"
              circle
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import coreData from "@/mixins/coreDataMixin";

export default {
  name: "UsersTable",
  mixins: [coreData],

  data() {
    return {
      suspensionReason: "",
      filter: "",
      dialogNoInvoice: false,
      showParticipantsDialog: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialog: false,
      premiumDialog: false,
      dialogDelete: false,
      search: "",
      selectedPremiumPeriod: null,
      premiumPeriods: [
        { value: 1, text: "1 Monat" },
        { value: 3, text: "3 Monate" },
        { value: 6, text: "6 Monate" },
        { value: 12, text: "12 Monate" },
      ],
      editedIndex: -1,
      editedItem: {
        name: "",
        email: "",
        age: "",
        salary: "",
      },
      defaultItem: {
        name: "",
        email: "",
        age: "",
        salary: "",
      },
      headers: [
        {
          text: "User",
          align: "start",
          cellClass: "border-bottom",
          sortable: true,
          value: "fullname",
          class:
            "text-secondary font-weight-bolder opacity-7 border-bottom ps-6",
        },
        {
          text: "Username",
          value: "username",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Status",
          value: "suspended",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "E-Mail",
          value: "email",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Bestätigt",
          value: "isVerified",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Aktionen",
          value: "_id",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
    };
  },
  methods: {
    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
    },
    grantPremium(item) {
      this.editedItem = item;
      this.premiumDialog = true;
    },
    showParticipants(item) {
      this.editedItem = item;
      // this.editedItem = Object.assign({}, item);
      this.showParticipantsDialog = true;
    },
    // deleteItemConfirm() {
    //   this.users.splice(this.editedIndex, 1);
    //   this.closeDelete();
    // },

    close() {
      this.dialog = false;
      this.showParticipantsDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeNoInvoice() {
      this.dialogNoInvoice = false;
      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      // });
    },

    downloadInvoiceModal(item) {
      if (item.payment_id.length == 0) {
        this.dialogNoInvoice = true;
      } else {
        this.downloadInvoice(item);
      }
    },

    save() {
      this.updateUser({
        id: this.editedItem.id,
        suspended: !this.editedItem.suspended,
        suspensionReason: this.editedItem.suspensionReason,
      });
      this.editedItem.suspended = !this.editedItem.suspended;
      if (!this.editedItem.suspended) {
        this.editedItem.suspensionReason = "";
      } else {
        this.editedItem.suspensionDate = new Date();
      }
      this.$store.dispatch("getUsers");
      // this.close();
    },
    setPremium() {
      this.editedItem.premiumDuration = this.selectedPremiumPeriod;
      this.updateUser({
        id: this.editedItem.id,
        premiumDuration: this.selectedPremiumPeriod,
      });
      this.selectedPremiumPeriod = null;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  computed: {
    users() {
      return this.$store.getters.users;
    },
    formTitle() {
      return "Übersicht Nutzerprofil";
    },
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
        : 0;
    },
  },
};
</script>
